import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import cardsFactory from 'utils/factories/card';

export const useCardHistory = ({ cardRef }: { cardRef: string }) => {
  const queryKey = cardsFactory.cardHistories(cardRef);
  const apiClient = useApi();

  return {
    queryResult: useQuery({
      queryKey,
      queryFn: () => apiClient.cards.apiCardsReferencecardHistoriesGet(cardRef),
    }),
    queryKey,
  };
};
